module.exports = __webpack_public_path__ + "img/landing.533b26f0.svg";